window.EM = window.EM || {};
window.EM.booking = window.EM.booking || {};

(function (ns) {
  var EVENT_RE = /\/([^\/]+)\/([^\/]+)\/booking/;
  var EVENT_NAME = undefined;
  var isLounge = document.location.pathname.indexOf("/" + site + "/lounge") > -1;
  var isLoungeHome = document.location.pathname === "/" + site + "/lounge";
  var isCamp = document.location.pathname.indexOf("booking-camp") > -1;
  var isLocationEvent = false;

  if (document.location.pathname.indexOf("/ottawa/sens") > -1) {
    isLoungeHome = true;
    isLounge = true;
  }

  var VENUE_TZ = "America/New_York";
  if (site === "brisbane") {
    VENUE_TZ = "Australia/Brisbane";
  } else if (site === "regina" || site === "saskatoon") {
    VENUE_TZ = "America/Regina";
  }

  var PAGE_BASE = KIOSK_MODE ? kioskPath : "/" + site;
  if (isLounge) {
    PAGE_BASE = "/" + site + "/lounge";
  } else if (!KIOSK_MODE && EVENT_RE.test(document.location.pathname)) {
    var matches = document.location.pathname.match(EVENT_RE);
    EVENT_NAME = matches[2];
    isLocationEvent = true;
    PAGE_BASE = "/" + site + "/" + EVENT_NAME;
  }

  var PAGE_CALENDAR = PAGE_BASE + "/booking";
  var PAGE_BOOK = PAGE_BASE + "/booking-book";
  var today = moment().tz(VENUE_TZ);
  if (KIOSK_MODE === true) {
    today.add(1, "days");
  }
  var NOW = today.clone().add(15, "minutes");
  var SIX_MONTHS = today.clone().add(7, "months").endOf("month");
  var START_SEARCH_DATE = today.clone();
  if (START_SEARCH_DATE.hour() <= 1) {
    START_SEARCH_DATE.add(-1, "day");
  }

  var DATES_PER_FETCH = site === "ottawa" ? 2 : 5;
  var ENABLE_PUSHSTATE = true;
  var SCROLL_ENABLED = !isLoungeHome && !isLocationEvent;
  if (isLoungeHome) {
    DATES_PER_FETCH = 6;
  }

  var DEFAULT_STATE = {
    action: "calendar",
    date: START_SEARCH_DATE.format("YYYYMMDD"),
    start: START_SEARCH_DATE.format("YYYYMMDD"),
    event: null,
    venue: null,
    time: null,
    players: null,
  };

  ns.config = {
    site: site,
    EVENT_RE: EVENT_RE,
    EVENT_NAME: EVENT_NAME,
    isLounge: isLounge,
    isLoungeHome: isLoungeHome,
    isCamp: isCamp,
    isLocationEvent: isLocationEvent,
    VENUE_TZ: VENUE_TZ,
    PAGE_BASE: PAGE_BASE,
    PAGE_CALENDAR: PAGE_CALENDAR,
    PAGE_BOOK: PAGE_BOOK,
    today: today,
    NOW: NOW,
    SIX_MONTHS: SIX_MONTHS,
    START_SEARCH_DATE: START_SEARCH_DATE,
    DATES_PER_FETCH: DATES_PER_FETCH,
    ENABLE_PUSHSTATE: ENABLE_PUSHSTATE,
    SCROLL_ENABLED: SCROLL_ENABLED,
    DEFAULT_STATE: DEFAULT_STATE,
  };
})(window.EM.booking);
